export const GAGRA_CANCELLATION_NOTICE = 'Бесплатная аннуляция за 14 дней до заезда';
